<template>
  <span class="inline-flex items-center gap-1.5 md:gap-[0.7rem] max-w-full" :class="{ 'w-full h-full': fill }">
    <span class="inline-flex shrink-0 leading-0 p-1 md:p-1.5 pr-1 md:pr-3"
      :class="fill ? 'w-full h-full' : compatto ? 'h-auto w-20' : 'h-auto w-30'" v-bind="$attrs">
      <img src="/logo/logoRCM.png" :alt="imgAlt" draggable="false"
        class="h-full max-w-full object-contain block dark:hidden w-full" :class="fill ? 'w-full' : 'w-auto'" />
      <img src="/logo/logoRCMdark.png" :alt="imgAlt" draggable="false"
        class="h-full max-w-full object-contain hidden dark:block w-full" :class="fill ? 'w-full' : 'w-auto'" />
    </span>
    <!-- «Sun» e «Riser» sono due elementi di un contenitore flex allineato sulla linea di base: i due testi condividono la stessa
         base per costruzione, senza dipendere dall'interlinea. Niente `truncate`: con `overflow: hidden` i glifi alti verrebbero tagliati. -->
    <span v-if="wordmark"
      class="inline-flex items-baseline whitespace-nowrap font-bold tracking-tight leading-none font-brand text-graphite dark:text-ivory-2"
      :class="compatto ? 'text-[1.75rem]' : 'text-[2.4rem]'"
      data-test="marchio-testuale"><span>Sun</span><span class="text-fiery-terracotta">Riser</span></span>
  </span>
</template>

<script setup>
defineOptions({ inheritAttrs: false });

const props = defineProps({
  wordmark: { type: Boolean, default: false },
  fill: { type: Boolean, default: false },
  // versione ridotta (logo e testo più piccoli) per le testate strette, come il menu laterale
  compatto: { type: Boolean, default: false },
});

// Il marchio testuale «SunRiser» (font-brand) sostituisce «SunCore»; il nome tecnico dell'app (2FA, PWA) cambia a parte.
const imgAlt = computed(() => (props.wordmark ? "" : "SunRiser"));
</script>
